export default __webpack_public_path__ + "static/media/Zombie.778709b0.webm";